import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import "./style.css";
import axios from "axios";
import { FeedPostMenu } from "../shared";
import EditPostPopup from "../../editPostPopup";

export default function GifFeed() {
  const { user } = useSelector((state) => ({ ...state }));
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("all");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [selectedGif, setSelectedGif] = useState(null);
  const [editingPost, setEditingPost] = useState(null);

  const handleEditPost = (post) => {
    setSelectedGif(null);
    setEditingPost(post);
  };
  const handlePostUpdated = (updatedPost) => {
    setPosts(prev => prev.map(p => p._id === updatedPost._id ? updatedPost : p));
    setEditingPost(null);
  };
  const handlePostDeleted = (postId) => {
    setPosts(prev => prev.filter(p => p._id !== postId));
    setSelectedGif(null);
  };

  const categories = [
    { id: "all", name: "Todos" },
    { id: "reactions", name: "Reações" },
    { id: "funny", name: "Engraçados" },
    { id: "animals", name: "Animais" },
    { id: "sports", name: "Esportes" },
    { id: "movies", name: "Filmes" },
    { id: "memes", name: "Memes" },
    { id: "anime", name: "Anime" },
  ];

  const fetchPosts = async (pageNum = 1) => {
    try {
      let url = `${process.env.REACT_APP_BACKEND_URL}/feed/gif?page=${pageNum}&limit=24`;
      if (category !== "all") url += `&category=${category}`;

      const { data } = await axios.get(url, { headers: { Authorization: `Bearer ${user.token}` } });
      if (pageNum === 1) setPosts(data.posts || []);
      else setPosts((prev) => [...prev, ...(data.posts || [])]);
      setHasMore((data.pagination?.page || 1) < (data.pagination?.pages || 1));
      setLoading(false);
    } catch (error) {
      console.error("Error fetching gifs:", error);
      setLoading(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { setPage(1); fetchPosts(1); }, [category]);

  if (loading && posts.length === 0) {
    return <div className="gif_feed_loading"><div className="gif_loader"></div><span>Carregando GIFs...</span></div>;
  }

  return (
    <div className="gif_feed">
      {categories.length > 0 && (
        <div className="simple_filter_bar">
          <div className="filter_buttons">
            {categories.map((filter) => (
              <button
                key={filter.id}
                className={`filter_btn ${category === filter.id ? "active" : ""}`}
                onClick={() => setCategory(filter.id)}
              >
                {filter.name}
              </button>
            ))}
          </div>
        </div>
      )}

      {posts.length === 0 ? (
        <div className="gif_feed_empty">
          <svg viewBox="0 0 24 24" fill="currentColor" width="64" height="64">
            <path d="M11.5 9H13v6h-1.5zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zm10 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1z"/>
          </svg>
          <h3>Nenhum GIF encontrado</h3>
          <p>Seja o primeiro a compartilhar um GIF!</p>
        </div>
      ) : (
        <div className="gif_masonry">
          {posts.map((post) => (
            <div key={post._id} className="gif_item" onClick={() => setSelectedGif(post)}>
              <img
                src={post.gifData?.gifUrl || post.images?.[0]?.url || post.images?.[0]}
                alt={post.gifData?.title || ""}
                loading="lazy"
              />
              <div className="gif_overlay">
                <Link to={`/profile/${post.user.username}`} className="gif_author" onClick={(e) => e.stopPropagation()}>
                  <img src={post.user.picture} alt="" />
                  <span>{post.user.first_name}</span>
                </Link>
                <div onClick={(e) => e.stopPropagation()}>
                  <FeedPostMenu
                    post={post}
                    onEdit={handleEditPost}
                    onPostDeleted={handlePostDeleted}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {hasMore && (
        <div className="gif_load_more">
          <button onClick={() => { setPage(p => p + 1); fetchPosts(page + 1); }} disabled={loading}>
            {loading ? "Carregando..." : "Ver mais GIFs"}
          </button>
        </div>
      )}

      {editingPost && (
        <EditPostPopup
          post={editingPost}
          user={user}
          setVisible={(visible) => !visible && setEditingPost(null)}
          onPostUpdated={handlePostUpdated}
        />
      )}

      {selectedGif && (
        <div className="gif_modal_overlay" onClick={() => setSelectedGif(null)}>
          <div className="gif_modal" onClick={(e) => e.stopPropagation()}>
            <button className="gif_modal_close" onClick={() => setSelectedGif(null)}>✕</button>
            <img src={selectedGif.gifData?.gifUrl || selectedGif.images?.[0]} alt="" />
            <div className="gif_modal_info">
              <Link to={`/profile/${selectedGif.user.username}`} className="gif_modal_author">
                <img src={selectedGif.user.picture} alt="" />
                <span>{selectedGif.user.first_name} {selectedGif.user.last_name}</span>
              </Link>
              {selectedGif.text && <p>{selectedGif.text}</p>}
              <div className="gif_modal_actions">
                <button className="gif_copy_btn" onClick={() => {
                  navigator.clipboard.writeText(selectedGif.gifData?.gifUrl || selectedGif.images?.[0]);
                }}>
                  Copiar Link
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
